var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("br"),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("H1", { staticClass: "pageTitle isPoppins" }, [
          _vm._v("Terms and Conditions")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "accSettingsForm top20" }, [
          _c("p", { staticStyle: { "line-height": "115%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial",
                  color: "#fff"
                }
              },
              [
                _vm._v("Last updated March 23"),
                _c("sup", [_vm._v("rd")]),
                _vm._v(",\n2022")
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center", "line-height": "115%" },
              attrs: { align: "center" }
            },
            [
              _c("span", {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "115%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "6.0pt",
                  "line-height": "115%",
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("AGREEMENT TO TERMS")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "These Terms and Conditions constitute a legally\nbinding agreement made between you, whether personally or on behalf of an\nentity (“you”) Slink, Inc. (“we,” “us” or “our”), concerning your access to and\nuse of the Slink.com website and services as well as any other media form,\nmedia channel, mobile website or mobile application related, linked, or\notherwise connected thereto (collectively, the “Site”). "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You agree that by accessing the Site, you have\nread, understood, and agree to be bound by all of these Terms and Conditions.\nIf you do not agree with all of these Terms and Conditions, then you are\nexpressly prohibited from using the Site and you must discontinue use\nimmediately."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Supplemental terms and conditions or documents\nthat may be posted on the Site from time to time are hereby expressly\nincorporated herein by reference. We reserve the right, in our sole discretion,\nto make changes or modifications to these Terms and Conditions at any time and\nfor any reason. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We will alert you about any changes by updating\nthe “Last updated” date of these Terms and Conditions, and you waive any right\nto receive specific notice of each such change. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "It is your responsibility to periodically review\nthese Terms and Conditions to stay informed of updates. You will be subject "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("to, and")]),
                _vm._v(
                  " will be deemed to have been made aware of and to\nhave accepted, the changes in any revised Terms and Conditions by your\ncontinued use of the Site after the date such revised Terms and Conditions are\nposted. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "The information provided on the Site is not\nintended for distribution to or use by any person or entity in any jurisdiction\nor country where such distribution or use would be contrary to law or\nregulation or which would subject us to any registration requirement within\nsuch jurisdiction or country. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Accordingly, those persons who choose to access\nthe Site from other locations do so on their own initiative and are solely\nresponsible for compliance with local laws, if and to the extent local laws are\napplicable. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  'The Site allows for the reservation of words or phrases and their conversion into URL redirection links ("Slinks").  These words or phrases can be\nexclusively reserved by Users on a first come, first served basis, except as it pertains to intellectual property restrictions outlined in the COPYRIGHT INFRINGEMENT section of this document. '
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("INTELLECTUAL PROPERTY RIGHTS")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Unless otherwise indicated, the Site is our\nproprietary property and all source code, databases, functionality, software,\nwebsite designs, audio, video, text, photographs, and graphics on the Site\n(collectively, the “Content”) and the trademarks, service marks, and logos\ncontained therein (the “Marks”) are owned or controlled by us or licensed to\nus, and are protected by copyright and trademark laws and various other\nintellectual property rights and unfair competition laws of the United States,\nforeign jurisdictions, and international conventions. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "The Content and the Marks are provided on the\nSite “AS IS” for your information and personal use only. Except as expressly\nprovided in these Terms and Conditions, no part of the Site and no Content or\nMarks may be copied, reproduced, aggregated, republished, uploaded, posted,\npublicly displayed, encoded, translated, transmitted, distributed, sold,\nlicensed, or otherwise exploited for any commercial purpose whatsoever, without\nour express prior written permission."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Provided that you are eligible to use the Site,\nyou are granted a limited license to access and use the Site and to download or\nprint a copy of any portion of the Content to which you have properly gained\naccess solely for your personal, non-commercial use. We reserve all rights not\nexpressly granted to you in and to the Site, the Content and the Marks."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("USER REPRESENTATIONS")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v("By using the Site, you represent and warrant\nthat: ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(1) all registration information you submit will\nbe true, accurate, current, and complete;"
                ),
                _c("b", { staticStyle: { "mso-bidi-font-weight": "normal" } }),
                _vm._v(
                  "(2) you will maintain the accuracy of such information and promptly update\nsuch registration information as "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("necessary;")]),
                _c("b", { staticStyle: { "mso-bidi-font-weight": "normal" } })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c("b", { staticStyle: {} }, [
              _c(
                "span",
                { staticStyle: { "font-family": '"Arial",sans-serif' } },
                [_vm._v(" ")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v("(3) you have the legal "),
                _c("span", { staticClass: "GramE" }, [_vm._v("capacity")]),
                _vm._v(
                  "\nand you agree to comply with these Terms and Conditions; "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v("(4) you are not under the age of "),
                _c("span", { staticClass: "GramE" }, [_vm._v("13;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v("(5) not a minor in the jurisdiction in which you\n"),
                _c("span", { staticClass: "GramE" }, [_vm._v("reside[")]),
                _vm._v(
                  ", or if a minor, you have received parental\npermission to use the Site; "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(6) you will not access the Site through\nautomated or non-human means, whether through a bot, script, or "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("otherwise;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(7) you will not use the Site for any illegal or\nunauthorized "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("purpose;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(8) your use of the Site will not violate any\napplicable law or regulation."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(9) you understand that the Site provides recurring\nsubscription services (unless otherwise stated). When you acquire one of our\nservices, you agree to be "
                ),
                _c("span", { staticClass: "GramE" }, [
                  _vm._v("charged "),
                  _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                  _vm._v("automatically")
                ]),
                _vm._v(
                  " and periodically until\nyou explicitly cancel that service."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If you provide any information that is untrue,\ninaccurate, not current, or incomplete, we have the right to suspend or\nterminate your account and refuse any and all current or future use of the Site\n(or any portion thereof). "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("USER REGISTRATION")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You may be required to register with the Site.\nYou agree to keep your password confidential and will be responsible for all\nuse of your account and password. We reserve the right to remove, reclaim, or\nchange a username you select if we determine, in our sole discretion, that such\nusername is inappropriate, obscene, or otherwise objectionable."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("SUBSCRIPTIONS")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  'The Site provides services on a subscription basis. The cost and length of these subscriptions is listed on the "GET" page of the Site.  When you purchase a subscription for one slink, you are entitled to control the redirection \nURL for that slink for the length of the subscription term.  In addition, the slink subscription entitles you to the use of a number of subslinks derived from the original slink you reserved under the subscription purchased. Subscriptions will automatically renew at the end of their term. You will receive an email as the renewal date approaches alerting\nyou of the pending renewal. You can cancel your subscriptions at any time. The services within a subscription will remain active until the expiration date of the subscription, you are not entitled to any refunds even if you cancel your subscription. All sales are final. On the expiration date of a subscription, if the subscription was not previously cancelled, we will attempt a charge for the new subscription period.\nIf the charge fails, you will have a grace period of seven days in which to provide a valid payment method and re-process the transaction. If payment has not been secured at the end of the seven day grace period, the slinks and subslinks within the expired subscriptions will be removed from your account\nand made available for others to acquire. The yearly subscription to a slink covers up to 5 million redirections. A redirection happens every time a slink is executed and a redirection to your designated URL takes place.  If your slink exceeds the 5 million\nredirects limit within a subscription year, additional blocks of redirects can be added to your slink. Each additional block entitles you to one million redirects. The cost of each additional block is $5.99. You will be notified if your slink is approching a redirect limit so you can decide whether to add redirect blocks or not.'
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("PROHIBITED ACTIVITIES")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You may not access or use the Site for any\npurpose other than that for which we make the Site available. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v("As a user of the Site, you agree not to:")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("1."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "systematically\nretrieve data or other content from the Site to create or compile, directly or\nindirectly, a collection, compilation, database, or directory without written\npermission from us."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("2."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "make any\nunauthorized use of the Site, including collecting usernames and/or email\naddresses of users by electronic or other means for the purpose of sending\nunsolicited email, or creating user accounts by automated means or under false\npretenses."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("3."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "use a\nbuying agent or purchasing agent to make purchases on the Site."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("4."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "circumvent,\ndisable, or otherwise interfere with security-related features of the Site,\nincluding features that prevent or restrict the use or copying of any Content\nor enforce limitations on the use of the Site and/or the Content contained\ntherein."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("5."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "engage in\nunauthorized framing of or linking to the Site."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("6."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "trick,\ndefraud, or mislead us and other users, especially in any attempt to learn\nsensitive account information such as user "
                  ),
                  _c("span", { staticClass: "GramE" }, [_vm._v("passwords;")])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("7."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "make\nimproper use of our support services or submit false reports of abuse or\nmisconduct."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("8."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "engage in\nany automated use of the system, such as using scripts to send comments or\nmessages, or using any data mining, robots, or similar data gathering and\nextraction tools."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("9."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("      ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "interfere\nwith, disrupt, or create an undue burden on the Site or the networks or\nservices connected to the Site."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("10."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "attempt to\nimpersonate another user or person or use the username of another user."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("11."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [_vm._v("sell or\notherwise transfer your profile.")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("12."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "use any\ninformation obtained from the Site in order to harass, abuse, or harm another\nperson."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("13."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "use the\nSite as part of any effort to compete with us."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("14."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "decipher,\ndecompile, disassemble, or reverse engineer any of the software comprising or\nin any way making up a part of the Site."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("15."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "attempt to\nbypass any measures of the Site designed to prevent or restrict access to the\nSite, or any portion of the Site."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("16."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "harass,\nannoy, intimidate, or threaten any of our employees or agents engaged in\nproviding any portion of the Site to you."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("17."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "delete the\ncopyright or other proprietary rights notice from any Content."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("18."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "copy or\nadapt the Site’s software, including but not limited to, HTML, JavaScript, or\nother code."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("19."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "upload or\ntransmit (or attempt to upload or to transmit) viruses, Trojan horses, or other\nmaterial, including excessive use of capital letters and spamming (continuous\nposting of repetitive text), that interferes with any party’s uninterrupted use\nand enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes\nwith the use, features, functions, operation, or maintenance of the Site."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("20."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "upload or\ntransmit (or attempt to upload or to transmit) any material that acts as a\npassive or active information collection or transmission mechanism, including\nwithout limitation, clear graphics interchange formats (“gifs”), 1×1 "
                  ),
                  _c("span", { staticClass: "GramE" }, [_vm._v("pixels")]),
                  _vm._v(
                    ", web bugs, cookies, or other similar devices\n(sometimes referred to as “spyware” or “passive collection mechanisms” or “"
                  ),
                  _c("span", { staticClass: "SpellE" }, [_vm._v("pcms")]),
                  _vm._v("”).")
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("21."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "except as\nmay be the result of standard search engine or Internet browser usage, use,\nlaunch, develop, or distribute any automated system, including without\nlimitation, any spider, robot, cheat utility, scraper, or offline reader that\naccesses the Site, or using or launching any unauthorized script or other\nsoftware."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("22."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "disparage,\ntarnish, or otherwise harm, in our opinion, us and/or the Site."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "28.35pt",
                "text-indent": "-21.25pt",
                "mso-list": "l0 level1 lfo1"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("23."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("  ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "use the\nSite in a manner inconsistent with any applicable laws or regulations."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c("span", { staticStyle: {} }, [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "16.0pt",
                    "line-height": "150%",
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [_vm._v("USER GENERATED CONTRIBUTIONS")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "16.0pt",
                  "line-height": "150%",
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  'The Site may invite you to chat, contribute to,\nor participate in blogs, message boards, online forums, and other\nfunctionality, and may provide you with the opportunity to create, submit,\npost, display, transmit, perform, publish, distribute, or broadcast content and\nmaterials to us or on the Site, including but not limited to text, writings,\nvideo, audio, photographs, graphics, comments, suggestions, or personal\ninformation or other material (collectively, "Contributions"). '
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Contributions may be viewable by other users of\nthe Site and through third-party websites. As such, any Contributions you\ntransmit may be treated as non-confidential and non-proprietary. When you\ncreate or make available any Contributions, you thereby represent and warrant\nthat:"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("1."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "the\ncreation, distribution, transmission, public display, or performance, and the\naccessing, downloading, or copying of your Contributions do not and will not\ninfringe the proprietary rights, including but not limited to the copyright,\npatent, trademark, trade secret, or moral rights of any third party."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("2."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "you are\nthe creator and owner of or have the necessary licenses, rights, consents,\nreleases, and permissions to use and to authorize us, the Site, and other users\nof the Site to use your Contributions in any manner contemplated by the Site\nand these Terms and Conditions."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("3."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "you have\nthe written consent, release, and/or permission of each and every identifiable\nindividual person in your Contributions to use the name or likeness of each and\nevery such identifiable individual person to enable inclusion and use of your\nContributions in any manner contemplated by the Site and these Terms and\nConditions."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("4."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions are not false, inaccurate, or misleading."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("5."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions are not unsolicited or unauthorized advertising, promotional\nmaterials, pyramid schemes, chain letters, spam, mass mailings, or other forms\nof solicitation."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("6."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions are not obscene, lewd, lascivious, filthy, violent, harassing,\nlibelous, slanderous, or otherwise objectionable (as determined by us)."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("7."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions do not ridicule, mock, disparage, intimidate, or abuse anyone."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("8."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions do not advocate the violent overthrow of any government or\nincite, encourage, or threaten physical harm against another."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("9."),
                    _c(
                      "span",
                      { staticStyle: { font: '7.0pt "Times New Roman"' } },
                      [_vm._v("    ")]
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions do not violate any applicable law, regulation, or rule."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("10."),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' }
                    })
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your Contributions\ndo not violate the privacy or publicity rights of any third party."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("11."),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' }
                    })
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions do not contain any material that solicits personal information\nfrom anyone under the age of 18 or exploits people under the age of 18 in a\nsexual or violent manner."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("12."),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' }
                    })
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions do not violate any federal or state law concerning child\npornography, or otherwise intended to protect the health or well-being of "
                  ),
                  _c("span", { staticClass: "GramE" }, [_vm._v("minors;")])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("13."),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' }
                    })
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions do not include any offensive comments that are connected to race,\nnational origin, gender, sexual preference, or physical handicap."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "27.0pt",
                "text-indent": "-.25in",
                "mso-list": "l1 level1 lfo2"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "mso-fareast-font-family": "Arial" } },
                [
                  _c("span", { staticStyle: { "mso-list": "Ignore" } }, [
                    _vm._v("14."),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' }
                    })
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [
                  _vm._v(
                    "your\nContributions do not otherwise violate, or link to material that violates, any\nprovision of these Terms and Conditions, or any applicable law or regulation."
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": ".3in",
                "text-indent": "-.3in",
                "line-height": "150%"
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [_vm._v(" ")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Any use of the Site in violation of the\nforegoing violates these Terms and Conditions and may result in, among other\nthings, termination or suspension of your rights to use the Site. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_c("span", { staticStyle: { "mso-spacerun": "yes" } })]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("CONTRIBUTION LICENSE")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "By posting your Contributions to any part of the\nSite [or making Contributions accessible to the Site by linking your account\nfrom the Site to any of your social networking accounts or other websites], you\nautomatically grant, and you represent and warrant that you have the right to\ngrant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive,\ntransferable, royalty-free, fully-paid, worldwide right, and license to host,\nuse, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle,\narchive, store, cache, publicly perform, publicly display, reformat, translate,\ntransmit, excerpt (in whole or in part), and distribute such Contributions\n(including, without limitation, your image and voice) for any purpose,\ncommercial, advertising, or otherwise, and to prepare derivative works of, or\nincorporate into other works, such Contributions, and grant and authorize\nsublicenses of the foregoing. The use and distribution may occur in any media\nformats and through any media channels. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "This license will apply to any form, media, or\ntechnology now known or hereafter developed, and includes our use of your name,\ncompany name, and franchise name, as applicable, and any of the trademarks,\nservice marks, trade names, logos, and personal and commercial images you\nprovide. You waive all moral rights in your Contributions, and you warrant that\nmoral rights have not otherwise been asserted in your Contributions. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We do not assert any ownership over your\nContributions. You retain full ownership of all of your Contributions and any\nintellectual property "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("rights")]),
                _vm._v(
                  " or other proprietary\nrights associated with your Contributions. We are not liable for any statements\nor representations in your Contributions provided by you in any area on the\nSite. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You are solely responsible for your\nContributions to the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("Site")]),
                _vm._v(
                  " and you expressly agree to\nexonerate us from any and all responsibility and to refrain from any legal\naction against us regarding your Contributions. "
                ),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We have the right, in our sole and absolute\ndiscretion, (1) to edit, redact, or otherwise change any Contributions; (2) to\nre-categorize any Contributions to place them in more appropriate locations on\nthe Site; and (3) to pre-screen or delete any Contributions at any time and for\nany reason, without notice. We have no obligation to monitor your\nContributions. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _vm._v(" ")
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("MOBILE APPLICATION LICENSE")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v(" ")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v("Use License")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If you access the Site via a mobile application,\nthen we grant you a revocable, non-exclusive, non-transferable, limited right\nto install and use the mobile application on wireless electronic devices owned\nor controlled by you, and to access and use the mobile application on such\ndevices strictly in accordance with the terms and conditions of this mobile application\nlicense contained in these Terms and Conditions. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v("You shall not: ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(1) decompile, reverse engineer, disassemble,\nattempt to derive the source code of, or decrypt the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("application;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(2) make any modification, adaptation,\nimprovement, enhancement, translation, or derivative work from the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("application;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(3) violate any applicable laws, rules, or\nregulations in connection with your access or use of the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("application;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(4) remove, alter, or obscure any proprietary\nnotice (including any notice of copyright or trademark) posted by us or the\nlicensors of the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("application;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(5) use the application for any revenue\ngenerating endeavor, commercial enterprise, or other purpose for which it is\nnot designed or "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("intended;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(6) make the application available over a\nnetwork or other environment permitting access or use by multiple devices or\nusers at the same "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("time;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(7) use the application for creating a product,\nservice, or software that is, directly or indirectly, competitive with or in\nany way a substitute for the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("application;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(8) use the application to send automated\nqueries to any website or to send any unsolicited commercial "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("e-mail;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(9) use any proprietary information or any of\nour interfaces or our other intellectual property in the design, development,\nmanufacture, licensing, or distribution of any applications, accessories, or\ndevices for use with the application."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v("Apple and Android Devices")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "The following terms apply when you use a mobile\napplication obtained from either the Apple Store or Google Play (each an “App\nDistributor”) to access the Site: "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(1) the license granted to you for our mobile\napplication is limited to a non-transferable license to use the application on\na device that utilizes the Apple iOS or Android operating systems, as\napplicable, and in accordance with the usage rules set forth in the applicable\nApp Distributor’s terms of "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("service;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(2) we are responsible for providing any\nmaintenance and support services with respect to the mobile application as\nspecified in the terms and conditions of this mobile application license\ncontained in these Terms and Conditions or as otherwise required under\napplicable law, and you acknowledge that each App Distributor has no obligation\nwhatsoever to furnish any maintenance and support services with respect to the\nmobile "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("application;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(3) in the event of any failure of the mobile\napplication to conform to any applicable warranty, you may notify the\napplicable App Distributor, and the App Distributor, in accordance with its\nterms and policies, may refund the purchase price, if any, paid for the mobile\napplication, and to the maximum extent permitted by applicable law, the App\nDistributor will have no other warranty obligation whatsoever with respect to\nthe mobile "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("application;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v("(4) you represent and warrant that ("),
                _c("span", { staticClass: "SpellE" }, [_vm._v("i")]),
                _vm._v(
                  ") you are not located in a country that is subject to a\nU.S. government embargo, or that has been designated by the U.S. government as\na “terrorist supporting” country and (ii) you are not listed on any U.S.\ngovernment list of prohibited or restricted "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("parties;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(5) you must comply with applicable third-party\nterms of agreement when using the mobile application, e.g., if you have a VoIP\napplication, then you must not be in violation of their wireless data service\nagreement when using the mobile "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("application;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "6) you acknowledge and agree that the App\nDistributors are third-party beneficiaries of the terms and conditions in this\nmobile application license contained in these Terms and Conditions, and that\neach App Distributor will have the right (and will be deemed to have accepted\nthe right) to enforce the terms and conditions in this mobile application\nlicense contained in these Terms and Conditions against you as a third-party\nbeneficiary thereof."
                ),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_c("span", { staticStyle: { "mso-spacerun": "yes" } })]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("SOCIAL MEDIA")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "As part of the functionality of the Site, you\nmay link your account with online accounts you have with third-party service\nproviders (each such account, a “Third-Party Account”) by either: (1) providing\nyour Third-Party Account login information through the Site; or (2) allowing us\nto access your Third-Party Account, as is permitted under the applicable terms\nand conditions that govern your use of each Third-Party Account. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You represent and warrant that you are entitled\nto disclose your Third-Party Account login information to us and/or grant us\naccess to your Third-Party Account, without breach by you of any of the terms\nand conditions that govern your use of the applicable Third-Party Account, and\nwithout obligating us to pay any fees or making us subject to any usage\nlimitations imposed by the third-party service provider of the Third-Party\nAccount. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "By granting us access to any Third-Party\nAccounts, you understand that (1) we may access, make available, and store (if\napplicable) any content that you have provided to and stored in your Third-Party\nAccount (the “Social Network Content”) so that it is available on and through\nthe Site via your account, including without limitation any friend lists and\n(2) we may submit to and receive from your Third-Party Account additional\ninformation to the extent you are notified when you link your account with the\nThird-Party Account. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Depending on the Third-Party Accounts you choose\nand subject to the privacy settings that you have set in such Third-Party\nAccounts, personally identifiable information that you post to your Third-Party\nAccounts may be available on and through your account on the Site. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Please note that if a Third-Party Account or\nassociated service becomes unavailable or our access to such Third-Party\nAccount is terminated by the third-party service provider, then Social Network\nContent may no longer be available on and through the Site. You will have the\nability to disable the connection between your account on the Site and your\nThird-Party Accounts at any time. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE\nTHIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR THIRD-PARTY ACCOUNTS IS\nGOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We make no effort to review any Social Network\nContent for any purpose, including but not limited to, for accuracy, legality,\nor non-infringement, and we are not responsible for any Social Network Content.\n"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You acknowledge and agree that we may access\nyour email address book associated with a Third-Party Account and your contacts\nlist stored on your mobile device or tablet computer solely for purposes of\nidentifying and informing you of those contacts who have also registered to use\nthe Site. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You can deactivate the connection between the\nSite and your Third-Party Account by contacting us using the contact\ninformation below or through your account settings (if applicable). We will\nattempt to delete any information stored on our servers that was obtained\nthrough such Third-Party Account, except the username and profile picture that\nbecome associated with your account."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("SUBMISSIONS")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  'You acknowledge and agree that any questions,\ncomments, suggestions, ideas, feedback, or other information regarding the Site\n("Submissions") provided by you to us are non-confidential and shall\nbecome our sole property. We shall own exclusive rights, including all\nintellectual property rights, and shall be entitled to the unrestricted use and\ndissemination of these Submissions for any lawful purpose, commercial or\notherwise, without acknowledgment or compensation to you. '
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You hereby waive all moral rights to any such\nSubmissions, and you hereby warrant that any such Submissions are original with\nyou or that you have the right to submit such Submissions. You agree there\nshall be no recourse against us for any alleged or actual infringement or\nmisappropriation of any proprietary right in your Submissions. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c("span", { staticStyle: { "line-height": "150%" } }, [
                _vm._v("THIRD-PARTY WEBSITES AND CONTENT")
              ])
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  'The Site may contain (or you may be sent via the\nSite) links to other websites ("Third-Party Websites") as well as\narticles, photographs, text, graphics, pictures, designs, music, sound, video,\ninformation, applications, software, and other content or items belonging to or\noriginating from third parties ("Third-Party Content"). '
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Such Third-Party Websites and Third-Party Content\nare not investigated, monitored, or checked for accuracy, appropriateness, or\ncompleteness by us, and we are not responsible for any Third-Party Websites\naccessed through the Site or any Third-Party Content posted on, available\nthrough, or installed from the Site, including the content, accuracy,\noffensiveness, opinions, reliability, privacy practices, or other policies of\nor contained in the Third-Party Websites or the Third-Party Content. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Inclusion of, linking to, or permitting the use\nor installation of any Third-Party Websites or any Third-Party Content does not\nimply approval or endorsement thereof by us. If you decide to leave the Site\nand access the Third-Party Websites or to use or install any Third-Party\nContent, you do so at your own risk, and you should be aware these Terms and\nConditions no longer govern. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You should review the applicable terms and\npolicies, including privacy and data gathering practices, of any website to\nwhich you navigate from the Site or relating to any applications you use or\ninstall from the Site. Any purchases you make through Third-Party Websites will\nbe through other websites and from other companies, and we take no\nresponsibility whatsoever in relation to such purchases which are exclusively\nbetween you and the applicable third party. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You agree and acknowledge that we do not endorse\nthe products or services offered on Third-Party Websites and you shall hold us\nharmless from any harm caused by your purchase of such products or services. Additionally,\nyou shall hold us harmless from any losses sustained by you or harm caused to\nyou relating to or resulting in any way from any Third-Party Content or any\ncontact with Third-Party Websites. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("ADVERTISERS")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We allow advertisers to display their advertisements\nand other information in certain areas of the Site, such as sidebar\nadvertisements or banner advertisements. If you are an advertiser, you shall\ntake full responsibility for any advertisements you place on the Site and any\nservices provided on the Site or products sold through those advertisements. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Further, as an advertiser, you warrant and\nrepresent that you possess all rights and authority to place advertisements on\nthe Site, including, but not limited to, intellectual property rights, publicity\nrights, and contractual rights."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "[As an advertiser, you agree that such\nadvertisements are subject to our Digital Millennium Copyright Act (“DMCA”)\nNotice and Policy provisions as described below, and you understand and agree\nthere will be no refund or other compensation for DMCA takedown-related\nissues.] We simply provide the space to place such advertisements, and we have\nno other relationship with advertisers."
                ),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _c("b", { staticStyle: { "mso-bidi-font-weight": "normal" } })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c("b", { staticStyle: {} }, [
              _c(
                "span",
                { staticStyle: { "font-family": '"Arial",sans-serif' } },
                [_vm._v(" ")]
              )
            ]),
            _c("span", { staticStyle: { "font-family": '"Arial",sans-serif' } })
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("SITE MANAGEMENT")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v("We reserve the right, but not the obligation,\nto: ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(1) monitor the Site for violations of these Terms\nand "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("Conditions;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(2) take appropriate legal action against anyone\nwho, in our sole discretion, violates the law or these Terms and Conditions,\nincluding without limitation, reporting such user to law enforcement "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("authorities;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(3) in our sole discretion and without\nlimitation, refuse, restrict access to, limit the availability of, or disable\n(to the extent technologically feasible) any of your Contributions or any\nportion "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("thereof;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(4) in our sole discretion and without\nlimitation, notice, or liability, to remove from the Site or otherwise disable\nall files and content that are excessive in size or are in any way burdensome\nto our "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("systems;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(5) otherwise manage the Site in a manner\ndesigned to protect our rights and property and to facilitate the proper\nfunctioning of the Site."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("PRIVACY POLICY")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We care about data privacy and security. Please\nreview our "
                ),
                _c(
                  "b",
                  {
                    staticClass: "handCursor",
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/privacy")
                      }
                    }
                  },
                  [_vm._v("Privacy Policy")]
                ),
                _vm._v(
                  " posted on the Site. By using the Site, you\nagree to be bound by our Privacy Policy, which is incorporated into these Terms\nand Conditions. Please be advised the Site is hosted in the United States. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If you access the Site from the European Union,\nAsia, or any other region of the world with laws or other requirements governing\npersonal data collection, use, or disclosure that differ from applicable laws\nin the United States, then through your continued use of the Site, you are\ntransferring your data to the United States, and you expressly consent to have\nyour data transferred to and processed in the United States."
                )
              ]
            ),
            _c("span", {
              staticStyle: {
                "font-family": '"Verdana",sans-serif',
                "mso-fareast-font-family": "Verdana",
                "mso-bidi-font-family": "Verdana"
              }
            })
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Verdana",sans-serif',
                  "mso-fareast-font-family": "Verdana",
                  "mso-bidi-font-family": "Verdana"
                }
              },
              [
                _vm._v(
                  "You may request the deletion of your account and personal data as outlined in the Privacy Policy.  If you decide to delete your account\nyou agree to release all claims over the words or phrases you have reserved as Slinks within your account and that you are not entitled to any refunds as a result of this action.  The Slinks in your account will be released and become available for other users to reserve."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c("span", {
              staticStyle: {
                "font-family": '"Verdana",sans-serif',
                "mso-fareast-font-family": "Verdana",
                "mso-bidi-font-family": "Verdana"
              }
            }),
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Further,\nwe do not knowingly accept, request, or solicit information from children or\nknowingly market to children. Therefore, in accordance with the U.S. Children’s\nOnline Privacy Protection Act, if we receive actual knowledge that anyone under\nthe age of 13 has provided personal information to us without the requisite and\nverifiable parental consent, we will delete that information from the Site as\nquickly as is reasonably practical."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_c("span", { staticStyle: { "mso-spacerun": "yes" } })]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [
                  _vm._v(
                    "DIGITAL MILLENNIUM COPYRIGHT ACT\n(DMCA) NOTICE AND POLICY"
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v("Notifications")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We respect the intellectual property rights of\nothers. If you believe that any material available on or through the Site\ninfringes upon any copyright you own or control, please immediately notify our\nDesignated Copyright Agent using the contact information provided below (a\n“Notification”). "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "A copy of your Notification will be sent to the\nperson who posted or stored the material addressed in the Notification. Please\nbe advised that pursuant to federal law you may be held liable for damages if\nyou make material misrepresentations in a Notification. Thus, if you are not\nsure that material located on or linked to by the Site infringes your\ncopyright, you should consider first contacting an attorney."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "All Notifications should meet the requirements\nof DMCA 17 U.S.C. § 512(c)(3) and include the following information: "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(1) A physical or electronic signature of a\nperson authorized to act on behalf of the owner of an exclusive right that is\nallegedly "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("infringed;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(2) identification of the copyrighted work\nclaimed to have been infringed, or, if multiple copyrighted works on the Site\nare covered by the Notification, a representative list of such works on the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("Site;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(3) identification of the material that is claimed\nto be infringing or to be the subject of infringing activity and that is to be\nremoved or access to which is to be disabled, and information reasonably\nsufficient to permit us to locate the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("material;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(4) information reasonably sufficient to permit\nus to contact the complaining party, such as an address, telephone number, and,\nif available, an email address at which the complaining party may be "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("contacted;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(5) a statement that the complaining party has a\ngood faith belief that use of the material in the manner complained of is not\nauthorized by the copyright owner, its agent, or the "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("law;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(6) a statement that the information in the\nnotification is accurate, and under penalty of perjury, that the complaining\nparty is authorized to act on behalf of the owner of an exclusive right that is\nallegedly infringed upon."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c("i", { staticStyle: { "mso-bidi-font-style": "normal" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "12.0pt",
                      "line-height": "150%"
                    }
                  },
                  [_c("span", { staticStyle: { "mso-tab-count": "1" } })]
                )
              ]),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v("Counter Notification")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If you believe your own copyrighted material has\nbeen removed from the Site "
                ),
                _c("span", { staticClass: "GramE" }, [
                  _vm._v("as a result of")
                ]),
                _vm._v(
                  " a mistake or\nmisidentification, you may submit a written counter notification to us using\nthe contact information provided below (a “Counter Notification”). "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "To be an effective Counter Notification under\nthe DMCA, your Counter Notification must include substantially the following: "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(1) identification of the material that has been\nremoved or disabled and the location at which the material appeared before it\nwas removed or "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("disabled;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(2) a statement that you consent to the\njurisdiction of the Federal District Court in which your address is located, or\nif your address is outside the United States, for any judicial district in\nwhich we are "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("located;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(3) a statement that you will accept service of\nprocess from the party that filed the Notification or the party's "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("agent;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v("(4) your name, address, and telephone "),
                _c("span", { staticClass: "GramE" }, [_vm._v("number;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "(5) a statement under penalty of perjury that\nyou have a good faith belief that the material in question was removed or disabled\nas a result of a mistake or misidentification of the material to be removed or "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("disabled;")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v("(6) your physical or electronic signature.")]
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { "text-indent": "-.3in", "line-height": "150%" } },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [_vm._v(" ")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If you send us a valid, written Counter\nNotification meeting the requirements described above, we will restore your\nremoved or disabled material, unless we first receive notice from the party\nfiling the Notification informing us that such party has filed a court action\nto restrain you from engaging in infringing activity related to the material in\nquestion."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_c("span", { staticStyle: { "mso-spacerun": "yes" } })]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Please note that if you materially misrepresent\nthat the disabled or removed content was removed by mistake or\nmisidentification, you may be liable for damages, including costs and\nattorney's fees. Filing a false Counter Notification constitutes perjury."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("COPYRIGHT INFRINGEMENTS")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We respect the intellectual property rights of\nothers. If you believe that any material available on or through the Site\ninfringes upon any copyright you own or control, please immediately notify us\nusing the contact information provided below (a “Notification”). A copy of your\nNotification will be sent to the person who posted or stored the material\naddressed in the Notification. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Please be advised that pursuant to federal law\nyou may be held liable for damages if you make material misrepresentations in a\nNotification. Thus, if you are not sure that material located on or linked to\nby the Site infringes your copyright, you should consider first contacting an\nattorney."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c("span", { staticStyle: { "line-height": "150%" } }, [
                _vm._v(
                  "REGISTRATION OF SlinkS PROTECTED BY INTELLECTUAL PROPERTY\nRIGHTS"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Words or phrases that are protected by copyright,\ntrademark or any other form of intellectual property protections hold an\nimplicit right of use to the holders of those rights. "
                ),
                _c("span", { staticClass: "GramE" }, [
                  _vm._v("In the\nevent that")
                ]),
                _vm._v(" you have registered one such word or phrase as a "),
                _c("b", [_vm._v("Slink")]),
                _vm._v(
                  ",\nthe rightful holders of the intellectual property rights protecting such word\nor phrase may file a claim with us to have the control of that word or phrase\ntaken away from you and transferred to them."
                ),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _vm._v(
                  "Decisions on the validity of such claims will be made solely by us and you\nexpressly agree that they will not be subject to the Dispute Resolution clauses\noutlined below. "
                ),
                _c("b", [
                  _vm._v(
                    "You agree to not attempt to register words or phrases as Slinks\nwhich you know to be brand names, product names, service names or any other\nword or phrase that is likely to be protected by intellectual property rights\nthat you do not hold."
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("TERM AND TERMINATION")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "These Terms and Conditions shall remain in full\nforce and effect while you use the Site. WITHOUT LIMITING ANY OTHER PROVISION\nOF THESE TERMS AND CONDITIONS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION\nAND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING\nBLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON,\nINCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR\nCOVENANT CONTAINED IN THESE TERMS AND CONDITIONS OR OF ANY APPLICABLE LAW OR\nREGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE OR DELETE\n[YOUR ACCOUNT AND] ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME,\nWITHOUT WARNING, IN OUR SOLE DISCRETION. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If we terminate or suspend your account for any\nreason, you are prohibited from registering and creating a new account under\nyour name, a fake or borrowed name, or the name of any third party, even if you\nmay be acting on behalf of the third party. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "In addition to terminating or suspending your\naccount, we reserve the right to take appropriate legal action, including\nwithout limitation pursuing civil, criminal, and injunctive redress."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("MODIFICATIONS AND INTERRUPTIONS ")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We reserve the right to change, modify, or\nremove the contents of the Site at any time or for any reason at our sole\ndiscretion without notice. However, we have no obligation to update any\ninformation on our Site. We also reserve the right to modify or discontinue all\nor part of the Site without notice at any time. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We will not be liable to you or any third party\nfor any modification, price change, suspension, or discontinuance of the Site. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We cannot guarantee the Site will be available\nat all times. We may experience hardware, software, or other problems or need\nto perform maintenance related to the Site, resulting in interruptions, delays,\nor errors. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We reserve the right to change, revise, update,\nsuspend, discontinue, or otherwise modify the Site at any time or for any\nreason without notice to you. You agree that we have no liability whatsoever\nfor any loss, damage, or inconvenience caused by your inability to access or\nuse the Site during any downtime or discontinuance of the Site. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Nothing in these Terms and Conditions will be\nconstrued to obligate us to maintain and support the Site or to supply any\ncorrections, updates, or releases in connection therewith."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: {
                "margin-bottom": "2.0pt",
                "text-align": "left",
                "line-height": "150%"
              },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("GOVERNING\nLAW ")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "These Terms and Conditions and your use of the\nSite are governed by and construed in accordance with the laws of the State of Florida\nin the United States of America. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: {
                "margin-bottom": "2.0pt",
                "text-align": "left",
                "line-height": "150%"
              },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("DISPUTE\nRESOLUTION")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: {
                "margin-bottom": "5.0pt",
                "text-align": "left",
                "line-height": "150%",
                "mso-pagination": "none",
                "page-break-after": "auto"
              },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v("Informal Negotiations")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  'To expedite resolution and control the cost of\nany dispute, controversy, or claim related to these Terms and Conditions (each\na "Dispute" and collectively, the “Disputes”) brought by either you\nor us (individually, a “Party” and collectively, the “Parties”), the Parties\nagree to first attempt to negotiate any Dispute (except those Disputes\nexpressly provided below) informally for at least '
                ),
                _c("span", { staticStyle: {} }, [_vm._v("thirty (30)")]),
                _vm._v(
                  " days before initiating arbitration. Such informal\nnegotiations commence upon written notice from one Party to the other Party."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: {
                "margin-bottom": "5.0pt",
                "text-align": "left",
                "line-height": "150%",
                "mso-pagination": "none",
                "page-break-after": "auto"
              },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v("Binding Arbitration")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If the Parties are unable to resolve a Dispute\nthrough informal negotiations, the Dispute (except those Disputes expressly\nexcluded below) will be finally and exclusively resolved by binding\narbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD HAVE THE\nRIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  'The arbitration shall be commenced and conducted\nunder the Commercial Arbitration Rules of the American Arbitration Association\n("AAA") and, where appropriate, the AAA’s Supplementary Procedures\nfor Consumer Related Disputes ("AAA Consumer Rules"), both of which\nare available at the AAA website '
                )
              ]
            ),
            _c("a", { attrs: { href: "http://www.adr.org" } }, [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": '"Arial",sans-serif',
                    "mso-fareast-font-family": "Arial"
                  }
                },
                [_vm._v("www.adr.org")]
              )
            ]),
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(". ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Your arbitration fees and your share of\narbitrator compensation shall be governed by the AAA Consumer Rules and, where\nappropriate, limited by the AAA Consumer Rules. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "The arbitration may be conducted in person,\nthrough the submission of documents, by phone, or online. The arbitrator will\nmake a decision in "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("writing, but")]),
                _vm._v(
                  " need not provide a\nstatement of reasons unless requested by either Party. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "The arbitrator must follow applicable law, and\nany award may be challenged if the arbitrator fails to do so. Except where\notherwise required by the applicable AAA rules or applicable law, the\narbitration will take place in Miami-Dade County, Florida. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Except as otherwise provided herein, the Parties\nmay litigate in court to compel arbitration, stay proceedings pending\narbitration, or to confirm, modify, vacate, or enter judgment on the award\nentered by the arbitrator."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If for any reason, a Dispute proceeds in court\nrather than arbitration, the Dispute shall be commenced or prosecuted in the\nstate and federal courts located in Miami-Dade County, Florida, and the Parties\nhereby consent to, and waive all defenses of lack of personal jurisdiction, and\nforum non "
                ),
                _c("span", { staticClass: "SpellE" }, [_vm._v("conveniens")]),
                _vm._v(
                  " with respect to venue and\njurisdiction in such state and federal courts. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Application of the United Nations Convention on\nContracts for the International Sale of Goods and the "
                ),
                _c("span", { staticClass: "SpellE" }, [_vm._v("the")]),
                _vm._v(
                  "\nUniform Computer Information Transaction Act (UCITA) are excluded from these Terms\nand Conditions. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "In no event shall any Dispute brought by either\nParty related in any way to the Site be commenced more than one (1) years after\nthe cause of action arose. If this provision is found to be illegal or\nunenforceable, then neither Party will elect to arbitrate any Dispute falling\nwithin that portion of this provision found to be illegal or unenforceable and\nsuch Dispute shall be decided by a court of competent jurisdiction within the\ncourts listed for jurisdiction above, and the Parties agree to submit to the personal\njurisdiction of that court."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: {
                "margin-bottom": "5.0pt",
                "text-align": "left",
                "line-height": "150%",
                "mso-pagination": "none",
                "page-break-after": "auto"
              },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v("Restrictions")]
              )
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "The Parties agree that any arbitration shall be\nlimited to the Dispute between the Parties individually. To the full extent\npermitted by law, (a) no arbitration shall be joined with any other proceeding;\n(b) there is no right or authority for any Dispute to be arbitrated on a class-action\nbasis or to utilize class action procedures; and (c) there is no right or\nauthority for any Dispute to be brought in a purported representative capacity\non behalf of the general public or any other persons."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticStyle: {
                "margin-bottom": "5.0pt",
                "text-align": "left",
                "line-height": "150%",
                "mso-pagination": "none",
                "page-break-after": "auto"
              },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "12.0pt", "line-height": "150%" }
                },
                [_vm._v("Exceptions to Informal Negotiations\nand Arbitration")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "The Parties agree that the following Disputes\nare not subject to the above provisions concerning informal negotiations and\nbinding arbitration: (a) any Disputes seeking to enforce or protect, or\nconcerning the validity of, any of the intellectual property rights of a Party;\n(b) any Dispute related to, or arising from, allegations of theft, piracy,\ninvasion of privacy, or unauthorized use; and (c) any claim for injunctive\nrelief. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If this provision is found to be illegal or\nunenforceable, then neither Party will elect to arbitrate any Dispute falling\nwithin that portion of this provision found to be illegal or unenforceable and\nsuch Dispute shall be decided by a court of competent jurisdiction within the\ncourts listed for jurisdiction above, and the Parties agree to submit to the\npersonal jurisdiction of that court."
                ),
                _c("b", { staticStyle: { "mso-bidi-font-weight": "normal" } })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c("b", { staticStyle: {} }, [
              _c(
                "span",
                { staticStyle: { "font-family": '"Arial",sans-serif' } },
                [_vm._v(" ")]
              )
            ]),
            _c("span", { staticStyle: { "font-family": '"Arial",sans-serif' } })
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("CORRECTIONS")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "There may be information on the Site that\ncontains typographical errors, inaccuracies, or omissions that may relate to\nthe Site, including descriptions, pricing, availability, and various other\ninformation. We reserve the right to correct any errors, inaccuracies, or\nomissions and to change or update the information on the Site at any time,\nwithout prior notice."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("DISCLAIMER")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "THE SITE IS PROVIDED ON AN AS-IS AND\nAS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL\nBE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL\nWARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF,\nINCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY,\nFITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES\nOR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR\nTHE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY\nOR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND\nMATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,\nRESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS\nTO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR\nFINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF\nTRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE\nLIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR\n(6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR\nDAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED,\nTRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT,\nENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE\nADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED\nWEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER\nADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR\nMONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF\nPRODUCTS OR SERVICES. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "AS WITH THE PURCHASE OF A PRODUCT OR SERVICE\nTHROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND\nEXERCISE CAUTION WHERE APPROPRIATE."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("LIMITATIONS OF LIABILITY")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES,\nOR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL,\nEXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT,\nLOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE,\nEVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "NOTWITHSTANDING ANYTHING TO THE CONTRARY\nCONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS\nOF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF\nANY, BY YOU TO US IN CONNECTION TO THE SPECIFIC SERVICE IN THE DISPUTE DURING\nTHE 12 MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION ARISING. CERTAIN STATE LAWS DO\nNOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF\nCERTAIN DAMAGES. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("INDEMNIFICATION")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You agree to defend, indemnify, and hold us\nharmless, including our subsidiaries, affiliates, and all of our respective\nofficers, agents, partners, and employees, from and against any loss, damage,\nliability, claim, or demand, including reasonable attorneys’ fees and expenses,\nmade by any third party due to or arising out of: (1) [your Contributions]; (2)\nuse of the Site; (3) breach of these Terms and Conditions; (4) any breach of\nyour representations and warranties set forth in these Terms and Conditions;\n(5) your violation of the rights of a third party, including but not limited to\nintellectual property rights; or (6) any overt harmful act toward any other\nuser of the Site with whom you connected via the Site. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Notwithstanding the foregoing, we reserve the\nright, at your expense, to assume the exclusive defense and control of any\nmatter for which you are required to indemnify us, and you agree to cooperate,\nat your expense, with our defense of such claims. We will use reasonable\nefforts to notify you of any such claim, action, or proceeding which is subject\nto this indemnification upon becoming aware of it. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_c("span", { staticStyle: { "mso-spacerun": "yes" } })]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v("USER DATA")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "We will maintain certain data that you transmit\nto the Site for the purpose of managing the Site, as well as data relating to\nyour use of the Site. Although we perform regular routine backups of data, you\nare solely responsible for all data that you transmit or that relates to any\nactivity you have undertaken using the Site. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You agree that we shall have no liability to you\nfor any loss or corruption of any such data, and you hereby waive any right of\naction against us arising from any such loss or corruption of such data."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c("b", { staticStyle: {} }, [
              _c(
                "span",
                { staticStyle: { "font-family": '"Arial",sans-serif' } },
                [_c("span", { staticStyle: { "mso-spacerun": "yes" } })]
              )
            ]),
            _c("span", {
              staticStyle: {
                "font-family": '"Arial",sans-serif',
                "mso-fareast-font-family": "Arial"
              }
            })
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [
                  _vm._v(
                    "ELECTRONIC COMMUNICATIONS, TRANSACTIONS,\nAND SIGNATURES"
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "Visiting the Site, sending us emails, and\ncompleting online forms constitute electronic communications. You consent to\nreceive electronic communications, and you agree that all agreements, notices,\ndisclosures, and other communications we provide to you electronically, via\nemail and on the Site, satisfy any legal requirement that such communication be\nin writing. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "YOU HEREBY AGREE TO THE USE OF ELECTRONIC\nSIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF\nNOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR\nVIA THE SITE. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You hereby waive any rights or requirements\nunder any statutes, regulations, rules, ordinances, or other laws in any\njurisdiction which require an original signature or delivery or retention of\nnon-electronic records, or to payments or the granting of credits by any means\nother than electronic means. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c("span", { staticStyle: { "line-height": "150%" } }, [
                _vm._v("MISCELLANEOUS")
              ])
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "These Terms and Conditions and any policies or\noperating rules posted by us on the Site constitute the entire agreement and\nunderstanding between you and us. Our failure to exercise or enforce any right\nor provision of these Terms and Conditions shall not operate as a waiver of such\nright or provision. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "These Terms and Conditions operate to the\nfullest extent permissible by law. We may assign any or all of our rights and\nobligations to others at any time. We shall not be responsible or liable for\nany loss, damage, delay, or failure to act caused by any cause beyond our\nreasonable control. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "If any provision or part of a provision of these\nTerms and Conditions is determined to be unlawful, void, or unenforceable, that\nprovision or part of the provision is deemed severable from these Terms and\nConditions and does not affect the validity and enforceability of any remaining\nprovisions. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "There is no joint venture, partnership,\nemployment or agency relationship created between you and us as a result of\nthese Terms and Conditions or use of the Site. You agree that these Terms and\nConditions will not be construed against us by virtue of having drafted them. "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "You hereby waive any and all defenses you may\nhave based on the electronic form of these Terms and Conditions and the lack of\nsigning by the parties hereto to execute these Terms and Conditions."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-size": "16.0pt", "line-height": "150%" }
                },
                [_vm._v(" ")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticStyle: { "text-align": "left", "line-height": "150%" },
              attrs: { align: "left" }
            },
            [
              _c("span", { staticStyle: { "line-height": "150%" } }, [
                _vm._v("CONTACT US ")
              ])
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _vm._v(
                  "In order to resolve a complaint regarding the\nSite or to receive further information regarding use of the Site, please\ncontact us at:"
                ),
                _c("b", { staticStyle: { "mso-bidi-font-weight": "normal" } })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [
                _c(
                  "a",
                  {
                    staticStyle: { color: "white" },
                    attrs: { href: "mailto:legal@slink.com" }
                  },
                  [_c("b", [_vm._v("legal@slink.com")])]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "12.0pt",
                "font-family": '"Arial",sans-serif',
                "mso-ansi-language": "EN-US",
                "mso-fareast-language": "ZH-TW"
              }
            },
            [
              _c("br", {
                staticStyle: { "mso-special-character": "line-break" },
                attrs: { clear: "all" }
              })
            ]
          ),
          _vm._v(" "),
          _c("p", [
            _c(
              "span",
              { staticStyle: { "font-family": '"Arial",sans-serif' } },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "line-height": "150%" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-fareast-font-family": "Arial"
                }
              },
              [_vm._v(" ")]
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1470d3da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1470d3da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Terms.vue
// module id = null
// module chunks = 